import { parse } from '@lib/parse';
import { Int } from '@model/Types/Int';
import { TYPES } from '@model/utils/types';
import { Type } from './Type';

export class Boolean extends Type {
    static getDefault() {
        return false;
    }

    static toValue(value): boolean {
        value = parse(value);

        return value === 1 || value === true || value === 'true';
    }

    public static hashArray(values: any): string {
        return [0]
            .concat(values)
            .map((v) => Int.toValue(!!v))
            .join('');
    }

    public static hashObject(values: any): string {
        return Boolean.hashArray(Object.values(values));
    }
}

Boolean[TYPES.TYPE] = 'boolean';

export const Bool = Boolean;
